export enum AxisTypeEnum {
   HORIZONTAL = "HORIZONTAL",
   VERTICAL = "VERTICAL",
}
